// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import {IEnvironment} from "./ienvironment";

export const environment:IEnvironment = {
  production: false
  ,applicationLogo: "/assets/images/logo-discoverandchange.dark.png"
  ,applicationLogoTitle: "Discover and Change"
  ,applicationTitle: "Assessment Intake System"
  ,token: "$1$oY9oz7o7$h2qAnr/1vc4TqT7Ac4hK9."
  ,stripePublicKey: "pk_live_Qrw8cLaapFskT6GTE4ozFXKg"
  ,stripeChargeName: "Discover and Change"
  ,features: {
    // can you add a client.
    "client.add": true
    // can you add/edit see the list of assessments on the assessment admin page.
    ,"assessments.manage": true
    // does the navigation link to the assessments admin show up
    ,"admin.assessments.navigation": true
    // the link back to addo's home page.
    ,"addo.dashboard.admin": true
    // can batteries be added, displayed, managed, etc.
    ,"assessments.battery.manage": true
    // does the client edit assessment email template display
    ,"assessments.manage.emailtemplate": true
    ,"wordpress.auth.check": false
    ,"admin.shop": true
    ,"assessments.tokens.enabled": true
    ,"assessments.reports.manage": true
  }
  ,useAddoReports: false
  ,apiURL: "https://assessment-api.discoverandchange.com/api/v1/"
  ,supportEmail: "info@discoverandchange.com"
  ,supportPhone: "(385) 233-9626"
  ,skinClasses: ['addo-blue-skin']
  ,navBarClass: 'navbar-light'
  ,reportHeaderImgURL: "/assets/images/addo-report-header1.png"
  ,partners: ['addo', 'apsats']
  ,disabledAssessments: []
  ,copyrightURL: "https://www.discoverandchange.com/"
  ,copyrightTitle: "Discover and Change, Inc"
  ,awsCognitoConfig: {
    awsCognitoRegion: 'us-east-1',
    userPool: {
      userPoolsId:"us-east-1_4McRrU0Wx",
      webClientId:"7c2ijpct85se7ddc1d9803bf6"
    }
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts